(function () {

  function setLock(active) {
    document.documentElement.classList.toggle('apella-plp-locked', !!active);
    document.body.classList.toggle('apella-plp-locked', !!active);
  }

  function setDrawerState(root, active) {
    root.classList.toggle('apella-facets-open', !!active);
    root.querySelectorAll('[data-apella-open-filter], [data-apella-open-sort]').forEach(function (button) {
      button.setAttribute('aria-expanded', active ? 'true' : 'false');
    });
    setLock(active);
  }

  function drawerDetails(root) {
    return root.querySelector('details.mobile-facets__disclosure');
  }

  function openDrawer(root, mode, trigger) {
    var summary = root.querySelector('.mobile-facets__open-wrapper');
    var details = drawerDetails(root);
    if (!summary || !details) return;
    root.__apellaLastFocus = trigger || document.activeElement;
    root.dataset.apellaMode = mode || 'filter';
    if (!details.hasAttribute('open')) summary.click();
    window.setTimeout(function () {
      setDrawerState(root, true);
      var focusTarget = mode === 'sort' ? root.querySelector('#SortBy-mobile-trigger, #SortBy-mobile:not([hidden])') : root.querySelector('.mobile-facets__heading');
      if (focusTarget && focusTarget.focus) focusTarget.focus({ preventScroll: true });
    }, 50);
  }

  function closeDrawer(root) {
    var details = drawerDetails(root);
    var closeButton = root.querySelector('.mobile-facets__close');
    if (details && details.hasAttribute('open')) {
      if (closeButton) closeButton.click();
      else details.removeAttribute('open');
    }
    root.removeAttribute('data-apella-mode');
    setDrawerState(root, false);
    window.setTimeout(function () { setDrawerState(root, false); }, 120);
    if (root.__apellaLastFocus && root.__apellaLastFocus.focus) {
      window.setTimeout(function () { root.__apellaLastFocus.focus({ preventScroll: true }); }, 20);
    }
  }

  function ensureDrawerBackButton(root) {
    var header = root.querySelector('.mobile-facets__header-inner, .mobile-facets__header');
    if (!header || header.querySelector('[data-apella-filter-back]')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'apella-filter-back';
    button.setAttribute('data-apella-filter-back', '');
    button.setAttribute('aria-label', 'Back to products');
    button.innerHTML = '<span class="apella-filter-back__icon" aria-hidden="true"><svg viewBox="0 0 16 16" focusable="false"><path d="M10.8 3.2 6 8l4.8 4.8-1.1 1.1L3.8 8l5.9-5.9 1.1 1.1Z"></path></svg></span><span>Back</span>';
    button.addEventListener('click', function () { closeDrawer(root); });
    header.insertBefore(button, header.firstChild);
  }

  function bindDrawer(root) {
    ensureDrawerBackButton(root);
    root.querySelectorAll('[data-apella-open-filter]').forEach(function (button) {
      if (button.dataset.apellaBound) return;
      button.dataset.apellaBound = '1';
      button.addEventListener('click', function () { openDrawer(root, 'filter', button); });
    });

    root.querySelectorAll('[data-apella-open-sort]').forEach(function (button) {
      if (button.dataset.apellaBound) return;
      button.dataset.apellaBound = '1';
      button.addEventListener('click', function () { openDrawer(root, 'sort', button); });
    });

    if (root.dataset.apellaCloseBound) return;
    root.dataset.apellaCloseBound = '1';

    function closeAfterClearAll(event) {
      if (event.type === 'keyup' && event.code !== 'Space') return;
      if (event.target.closest('[data-apella-clear-all]')) closeDrawer(root);
    }
    root.addEventListener('click', closeAfterClearAll);
    root.addEventListener('keyup', closeAfterClearAll);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('apella-facets-open')) closeDrawer(root);
    });

    document.addEventListener('click', function (event) {
      if (!root.classList.contains('apella-facets-open')) return;
      if (event.target.closest('.mobile-facets__close')) {
        window.setTimeout(function () { closeDrawer(root); }, 30);
        return;
      }
      var overlay = event.target.closest('.mobile-facets');
      if (overlay && !event.target.closest('.mobile-facets__inner')) closeDrawer(root);
    });
  }

  function syncDrawer(root) {
    var isOpen = !!root.querySelector('details.mobile-facets__disclosure[open]');
    root.classList.toggle('apella-facets-open', isOpen);
    if (!isOpen) setLock(false);
  }

  function updateHeroCount(root) {
    var count = root.querySelector('.apella-plp-hero__count');
    if (!count) return;
    var source = root.querySelector('#ProductCountDesktop, #ProductCount, .mobile-facets__count');
    var match = ((source && source.textContent) || '').match(/\d[\d,]*/);
    if (match) count.textContent = match[0] + ' styles';
  }

  function initSubcollectionNavigation(root) {
    root.querySelectorAll('[data-apella-subcollections]').forEach(function (navigation) {
      if (window.ApellaSubcollectionContext) window.ApellaSubcollectionContext.enhance(navigation);
      if (navigation.dataset.apellaSubcollectionBound) return;
      var track = navigation.querySelector('[data-apella-subcollection-track]');
      var previous = navigation.querySelector('[data-apella-subcollection-previous]');
      var next = navigation.querySelector('[data-apella-subcollection-next]');
      if (!track || !previous || !next) return;

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var frame = null;

      function update() {
        frame = null;
        var overflow = track.scrollWidth > track.clientWidth + 2;
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        navigation.dataset.atStart = atStart ? 'true' : 'false';
        navigation.dataset.atEnd = atEnd ? 'true' : 'false';
        previous.hidden = !overflow;
        next.hidden = !overflow;
        previous.disabled = atStart;
        next.disabled = atEnd;
      }

      function scheduleUpdate() {
        if (frame) return;
        frame = window.requestAnimationFrame(update);
      }

      function move(direction) {
        track.scrollBy({
          left: direction * Math.max(220, track.clientWidth * 0.72),
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }

      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', scheduleUpdate, { passive: true });
      navigation.addEventListener('apella:subcollections-updated', scheduleUpdate);
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      navigation.dataset.apellaSubcollectionBound = '1';
      update();
    });
  }

  function initImageReveal(root) {
    var mediaFrames = Array.prototype.slice.call(root.querySelectorAll('.apella-plp-grid .apella-card__media-frame'));
    if (!mediaFrames.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      mediaFrames.forEach(function (media) { media.classList.add('is-apella-revealed'); });
      root.classList.add('apella-image-reveal-ready');
      return;
    }

    if (!root.__apellaImageRevealObserver) {
      root.__apellaImageRevealObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio < 0.5) return;
          entry.target.classList.add('is-apella-revealed');
          observer.unobserve(entry.target);
        });
      }, { threshold: [0.5] });
    }

    var viewportWidth = document.documentElement.clientWidth;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    // Measure the new batch before changing classes that affect image geometry.
    var pendingFrames = mediaFrames.filter(function (media) {
      return !media.dataset.apellaRevealTracked;
    }).map(function (media) {
      var rect = media.getBoundingClientRect();
      var visibleWidth = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0));
      var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
      var visibleRatio = rect.width > 0 && rect.height > 0
        ? (visibleWidth * visibleHeight) / (rect.width * rect.height)
        : 0;
      return { media: media, visible: visibleRatio >= 0.5 };
    });
    pendingFrames.forEach(function (entry) {
      entry.media.dataset.apellaRevealTracked = '1';
      if (entry.visible) entry.media.classList.add('is-apella-revealed');
      else root.__apellaImageRevealObserver.observe(entry.media);
    });

    root.classList.add('apella-image-reveal-ready');
  }

  function initImagePreparation(root) {
    if (root.__apellaImagePreparation) {
      root.__apellaImagePreparation.refresh();
      return;
    }
    if (!window.matchMedia || !('IntersectionObserver' in window) || !HTMLImageElement.prototype.decode) return;
    var connection = navigator.connection;
    if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType))) return;
    var desktop = window.matchMedia('(min-width: 990px)');
    var prepared = new WeakSet();
    var observed = new Set();
    var nearby = new Set();
    var running = 0;
    var destroyed = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) nearby.add(entry.target);
        else nearby.delete(entry.target);
      });
      prepareNext();
    }, { rootMargin: '160px 0px 350px 0px', threshold: 0 });

    function prepareNext() {
      if (destroyed || !desktop.matches) return;
      // Only nearby primary images; never wait for decoding before revealing a card.
      while (running < 2 && nearby.size) {
        var media = nearby.values().next().value;
        nearby.delete(media);
        observer.unobserve(media);
        observed.delete(media);
        if (!root.contains(media)) continue;
        var image = media.querySelector('.apella-card__img--primary, .apella-card-gallery__image, .apella-card__img');
        if (!image || prepared.has(image) || !image.getAttribute('src')) continue;
        prepared.add(image);
        image.decoding = 'async';
        image.loading = 'eager';
        running += 1;
        try { image.decode().then(onPrepared, onPrepared); }
        catch (error) { onPrepared(); }
      }
    }

    function onPrepared() {
      running -= 1;
      prepareNext();
    }

    function refresh() {
      observed.forEach(function (media) {
        if (!desktop.matches || !root.contains(media)) {
          observer.unobserve(media);
          observed.delete(media);
          nearby.delete(media);
        }
      });
      if (!desktop.matches || destroyed) return;
      root.querySelectorAll('.apella-plp-grid .apella-card__media-frame').forEach(function (media) {
        var image = media.querySelector('.apella-card__img--primary, .apella-card-gallery__image, .apella-card__img');
        if (!image || prepared.has(image) || observed.has(media)) return;
        observed.add(media);
        observer.observe(media);
      });
    }

    function destroy() {
      destroyed = true;
      observer.disconnect();
      observed.clear();
      nearby.clear();
      desktop.removeEventListener('change', refresh);
      delete root.__apellaImagePreparation;
    }

    desktop.addEventListener('change', refresh);
    root.__apellaImagePreparation = { refresh: refresh, destroy: destroy };
    refresh();
  }

  function initCardEntrance(root) {
    if (root.__apellaCardEntrance) {
      root.__apellaCardEntrance.refresh();
      return;
    }
    if (!window.matchMedia || !('IntersectionObserver' in window) || !Element.prototype.animate) return;

    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktopMotion = window.matchMedia('(min-width: 990px)');
    var cards = new Map();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.12) revealRow(entry.target, false);
      });
    }, { rootMargin: '0px 0px -24px 0px', threshold: [0.12] });
    var activeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = cards.get(entry.target);
        if (!entry.isIntersecting && state && state.animation) settle(entry.target, state);
      });
    }, { rootMargin: '160px 0px', threshold: 0 });

    function settle(item, state) {
      state.done = true;
      observer.unobserve(item);
      activeObserver.unobserve(item);
      if (state.animation) state.animation.cancel();
      state.animation = null;
      item.classList.remove('is-apella-entrance-pending', 'is-apella-card-entering', 'is-apella-card-stacking');
    }

    function rowStart(target) {
      var top = target.offsetTop;
      var first = target;
      while (first.previousElementSibling && Math.abs(first.previousElementSibling.offsetTop - top) < 2) {
        first = first.previousElementSibling;
      }
      return first;
    }

    function revealRow(target, immediate) {
      var state = cards.get(target);
      if (!state || state.done) return;
      var grid = target.parentElement;
      var top = target.offsetTop;
      var row = [];
      var first = rowStart(target);
      for (var item = first; item && Math.abs(item.offsetTop - top) < 2; item = item.nextElementSibling) {
        var candidate = cards.get(item);
        if (candidate && !candidate.done) row.push({ item: item, state: candidate, rect: item.getBoundingClientRect() });
      }
      var gridRect = grid.getBoundingClientRect();
      var center = gridRect.left + gridRect.width / 2;
      var desktop = desktopMotion.matches;
      var firstRow = Math.abs(grid.firstElementChild.offsetTop - top) < 2;
      var stack = desktop && firstRow && row.length > 1;
      var skipEntrance = immediate || motion.matches;

      row.forEach(function (card, index) {
        settle(card.item, card.state);
        if (skipEntrance || card.item.contains(document.activeElement)) return;
        var distance = center - (card.rect.left + card.rect.width / 2);
        var x = stack ? distance : desktop ? 0 : (index % 2 === 0 ? 1 : -1) * Math.min(90, card.rect.width * 0.4);
        var y = stack ? (row.length - index - 1) * 4 : desktop ? Math.min(80, card.rect.height * 0.16) : 0;
        card.item.classList.add('is-apella-card-entering');
        if (stack) card.item.classList.add('is-apella-card-stacking');
        try {
          var animation = card.item.animate([
            { transform: 'translate3d(' + x + 'px,' + y + 'px,0) rotate(0deg) scale(' + (stack ? 0.96 : 1) + ')', opacity: stack ? 1 : 0 },
            { transform: 'translate3d(0,0,0) rotate(0deg) scale(1)', opacity: 1 }
          ], {
            duration: stack ? 1050 : desktop ? 720 : 680,
            delay: stack ? 100 : index * (desktop ? 60 : 70),
            easing: stack ? 'cubic-bezier(0.32, 0, 0.2, 1)' : desktop ? 'cubic-bezier(0.25, 0.65, 0.3, 1)' : 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'backwards'
          });
          card.state.animation = animation;
          activeObserver.observe(card.item);
          animation.onfinish = function () { settle(card.item, card.state); };
        } catch (error) {
          settle(card.item, card.state);
        }
      });
    }

    function refresh() {
      cards.forEach(function (state, item) {
        if (!root.contains(item)) {
          settle(item, state);
          cards.delete(item);
        }
      });
      var pendingCards = Array.prototype.filter.call(root.querySelectorAll('.apella-plp-grid > .grid__item'), function (item) {
        return !cards.has(item) && item.querySelector('.apella-card');
      }).map(function (item) {
        return { item: item, skip: motion.matches || item.getBoundingClientRect().bottom <= 0 || item.contains(document.activeElement) };
      });
      pendingCards.forEach(function (entry) {
        var item = entry.item;
        var state = { done: false, animation: null };
        cards.set(item, state);
        if (entry.skip) {
          settle(item, state);
          return;
        }
        item.classList.add('is-apella-entrance-pending');
        observer.observe(item);
      });
    }

    function onInteraction(event) {
      var item = event.target.closest('.apella-plp-grid > .grid__item');
      if (!item || !cards.has(item)) return;
      revealRow(item, true);
      var top = item.offsetTop;
      for (var sibling = rowStart(item); sibling && Math.abs(sibling.offsetTop - top) < 2; sibling = sibling.nextElementSibling) {
        var state = cards.get(sibling);
        if (state && state.animation) settle(sibling, state);
      }
    }

    function onResize() {
      cards.forEach(function (state, item) {
        if (state.animation) settle(item, state);
      });
    }

    function onMotionChange() {
      if (motion.matches) cards.forEach(function (state, item) { settle(item, state); });
    }

    function destroy() {
      cards.forEach(function (state, item) { settle(item, state); });
      observer.disconnect();
      activeObserver.disconnect();
      cards.clear();
      root.removeEventListener('focusin', onInteraction);
      root.removeEventListener('pointerdown', onInteraction);
      window.removeEventListener('resize', onResize);
      motion.removeEventListener('change', onMotionChange);
      delete root.__apellaCardEntrance;
    }

    root.addEventListener('focusin', onInteraction);
    root.addEventListener('pointerdown', onInteraction);
    window.addEventListener('resize', onResize, { passive: true });
    motion.addEventListener('change', onMotionChange);
    root.__apellaCardEntrance = { refresh: refresh, destroy: destroy };
    refresh();
  }

  function loadGalleryImage(slide) {
    if (!slide) return;
    var image = slide.querySelector('img[data-src], img[data-srcset]');
    if (!image) return;
    if (image.dataset.srcset) {
      image.srcset = image.dataset.srcset;
      image.removeAttribute('data-srcset');
    }
    if (image.dataset.src) {
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
    }
  }

  function initCardGalleries(root) {
    root.querySelectorAll('[data-apella-card-gallery]').forEach(function (gallery) {
      if (gallery.dataset.apellaGalleryBound) return;

      var track = gallery.querySelector('[data-apella-gallery-track]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-apella-gallery-slide]'));
      if (!track || slides.length < 2) return;

      var previous = gallery.querySelector('[data-apella-gallery-previous]');
      var next = gallery.querySelector('[data-apella-gallery-next]');
      var status = gallery.querySelector('[data-apella-gallery-status]');
      var currentIndex = 0;
      var renderedIndex = -1;
      var scrollFrame = null;
      var navigationToken = 0;
      var pointerStartX = 0;
      var pointerStartY = 0;
      var didDrag = false;
      var fineHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function loadAround(index) {
        loadGalleryImage(slides[index]);
        loadGalleryImage(slides[index - 1]);
        loadGalleryImage(slides[index + 1]);
      }

      function update(index) {
        currentIndex = Math.max(0, Math.min(slides.length - 1, index));
        if (currentIndex === renderedIndex) return;
        renderedIndex = currentIndex;
        gallery.style.setProperty('--apella-gallery-index', currentIndex);
        slides.forEach(function (slide, slideIndex) {
          slide.setAttribute('aria-hidden', slideIndex === currentIndex ? 'false' : 'true');
        });
        if (previous) previous.disabled = currentIndex === 0;
        if (next) next.disabled = currentIndex === slides.length - 1;
        if (status) status.textContent = 'Image ' + (currentIndex + 1) + ' of ' + slides.length;
        loadGalleryImage(slides[currentIndex]);
      }

      function closestSlideIndex() {
        var trackRect = track.getBoundingClientRect();
        var trackCenter = trackRect.left + (trackRect.width / 2);
        var closestIndex = 0;
        var closestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var rect = slide.getBoundingClientRect();
          var distance = Math.abs((rect.left + (rect.width / 2)) - trackCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        return closestIndex;
      }

      function goTo(index) {
        var targetIndex = Math.max(0, Math.min(slides.length - 1, index));
        var targetLeft = slides[targetIndex].offsetLeft;
        var requestToken = ++navigationToken;
        var startLeft = track.scrollLeft;
        var distance = targetLeft - startLeft;
        var startedAt = null;
        var duration = 360;
        loadAround(targetIndex);
        update(targetIndex);

        if (reduceMotion || Math.abs(distance) < 1) {
          gallery.classList.remove('is-apella-gallery-animating');
          track.scrollLeft = targetLeft;
          return;
        }

        gallery.classList.add('is-apella-gallery-animating');

        function animateScroll(timestamp) {
          if (requestToken !== navigationToken) return;
          if (startedAt === null) startedAt = timestamp;
          var progress = Math.min(1, (timestamp - startedAt) / duration);
          var eased = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - (Math.pow(-2 * progress + 2, 3) / 2);
          track.scrollLeft = startLeft + (distance * eased);
          if (progress < 1) window.requestAnimationFrame(animateScroll);
          else {
            track.scrollLeft = targetLeft;
            gallery.classList.remove('is-apella-gallery-animating');
          }
        }

        window.requestAnimationFrame(animateScroll);
      }

      track.addEventListener('scroll', function () {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(function () {
          scrollFrame = null;
          if (gallery.classList.contains('is-apella-gallery-animating')) return;
          update(closestSlideIndex());
        });
      }, { passive: true });

      track.addEventListener('pointerdown', function (event) {
        loadAround(currentIndex);
        navigationToken += 1;
        gallery.classList.remove('is-apella-gallery-animating');
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        didDrag = false;
      }, { passive: true });

      gallery.addEventListener('pointerenter', function () { loadAround(currentIndex); }, { once: true, passive: true });
      gallery.addEventListener('focusin', function () { loadAround(currentIndex); }, { once: true });

      track.addEventListener('pointermove', function (event) {
        var deltaX = Math.abs(event.clientX - pointerStartX);
        var deltaY = Math.abs(event.clientY - pointerStartY);
        if (deltaX > 8 && deltaX > deltaY) {
          didDrag = true;
        }
      }, { passive: true });

      track.addEventListener('click', function (event) {
        if (!didDrag) return;
        event.preventDefault();
        event.stopPropagation();
        didDrag = false;
      });

      track.addEventListener('wheel', function (event) {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
          navigationToken += 1;
          gallery.classList.remove('is-apella-gallery-animating');
        }
      }, { passive: true });

      if (previous) previous.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.detail > 0) previous.blur();
        goTo(currentIndex - 1);
      });

      if (next) next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.detail > 0) next.blur();
        goTo(currentIndex + 1);
      });

      if (fineHover && gallery.dataset.apellaHoverSecondary === 'true') {
        gallery.addEventListener('mouseenter', function () {
          if (currentIndex === 1) return;
          goTo(1);
        });
        gallery.addEventListener('mouseleave', function () {
          goTo(0);
        });
      }

      gallery.dataset.apellaGalleryBound = '1';
      gallery.style.setProperty('--apella-gallery-count', slides.length);
      gallery.classList.add('is-apella-gallery-ready');
      update(0);
    });
  }

  function initInfinite(root) {
    if (root.dataset.apellaInfiniteScroll !== 'true' && !root.querySelector('[data-apella-infinite]')) return;
    var currentBlock = root.querySelector('[data-apella-infinite]');
    if (root.__apellaInfiniteBlock === currentBlock && root.dataset.apellaInfiniteBound) return;
    if (root.__apellaInfiniteObserver) {
      root.__apellaInfiniteObserver.disconnect();
      root.__apellaInfiniteObserver = null;
    }
    var block = root.querySelector('[data-apella-infinite]');
    var grid = root.querySelector('#product-grid');
    var complete = root.querySelector('[data-apella-infinite-complete]');
    var typeComplete = root.querySelector('[data-apella-type-complete]');
    if (!grid) return;

    root.dataset.apellaInfiniteBound = '1';
    root.__apellaInfiniteBlock = block;

    if (!block) {
      if (complete) complete.hidden = false;
      if (typeComplete) typeComplete.hidden = false;
      return;
    }

    var button = block.querySelector('[data-apella-load-more]');
    var loading = block.querySelector('[data-apella-infinite-loading]');
    var mode = block.getAttribute('data-mode') || root.dataset.apellaInfiniteMode || 'auto_with_button_fallback';
    var isLoading = false;
    var nextUrl = block.getAttribute('data-next-url');

    function setComplete() {
      block.hidden = true;
      if (root.__apellaInfiniteObserver) {
        root.__apellaInfiniteObserver.disconnect();
        root.__apellaInfiniteObserver = null;
      }
      if (complete) complete.hidden = false;
      if (typeComplete) typeComplete.hidden = false;
    }

    function setLoading(active) {
      isLoading = active;
      if (button) { if ('disabled' in button) button.disabled = active; button.setAttribute('aria-disabled', active ? 'true' : 'false'); button.classList.toggle('is-loading', active); }
      if (loading) loading.hidden = !active;
    }

    function loadNext() {
      if (isLoading || !nextUrl) return;
      setLoading(true);
      fetch(nextUrl, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          if (!block.isConnected || !grid.isConnected) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('#product-grid');
          if (!nextGrid) throw new Error('Missing product grid in next page');

          Array.prototype.slice.call(nextGrid.children).forEach(function (item) {
            grid.appendChild(document.importNode(item, true));
          });

          var nextBlock = doc.querySelector('[data-apella-infinite]');
          nextUrl = nextBlock ? nextBlock.getAttribute('data-next-url') : '';
          if (nextUrl) block.setAttribute('data-next-url', nextUrl);
          else block.removeAttribute('data-next-url');

          document.dispatchEvent(new CustomEvent('apella:products-loaded', { detail: { root: root } }));
          document.dispatchEvent(new CustomEvent('apella:content:loaded', { detail: { root: grid } }));

          if (!nextUrl) setComplete();
        })
        .catch(function () {
          if (button) button.hidden = false;
          block.classList.add('is-fallback');
        })
        .finally(function () { setLoading(false); });
    }

    if (button) {
      button.addEventListener('click', function (event) { event.preventDefault(); loadNext(); });
      button.hidden = mode !== 'button' && 'IntersectionObserver' in window;
    }

    if (mode !== 'button' && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext();
        });
      }, { rootMargin: '700px 0px' });
      root.__apellaInfiniteObserver = observer;
      observer.observe(block);
    }
  }

  function bindGridRefresh(root) {
    if (root.dataset.apellaGridRefreshBound) return;
    var container = root.querySelector('#ProductGridContainer');
    if (!container || !('MutationObserver' in window)) return;
    root.dataset.apellaGridRefreshBound = '1';
    var timer = null;
    new MutationObserver(function (mutations) {
      var refreshed = mutations.some(function (mutation) {
        return mutation.type === 'childList' && mutation.target === container;
      });
      if (!refreshed) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        delete root.dataset.apellaInfiniteBound;
        root.__apellaInfiniteBlock = null;
        initInfinite(root);
        initImageReveal(root);
        initImagePreparation(root);
        initCardEntrance(root);
        initCardGalleries(root);
        updateHeroCount(root);
      }, 80);
    }).observe(container, { childList: true });
  }


  class ApellaSortSelect extends HTMLElement {
    connectedCallback() {
      if (this.controller || !this.closest('.apella-plp')) return;
      var select = this.querySelector('select');
      if (!select) return;
      this.querySelectorAll('.apella-sort__trigger, .apella-sort__options').forEach(function (element) { element.remove(); });
      this.controller = new AbortController();
      var signal = this.controller.signal;
      var label = this.parentElement.querySelector('label');
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.id = select.id + '-trigger';
      trigger.className = 'apella-sort__trigger';
      trigger.setAttribute('data-apella-sort-trigger', '');
      trigger.setAttribute('role', 'combobox');
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-autocomplete', 'none');
      if (select.hasAttribute('aria-describedby')) trigger.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));
      trigger.setAttribute('aria-label', label ? label.textContent.trim() : select.name);
      var caption = document.createElement('span');
      var compactSort = Boolean(this.closest('.apella-plp-sort-shell'));
      trigger.appendChild(caption);
      var arrow = document.createElement('span');
      arrow.className = 'apella-sort__arrow';
      arrow.setAttribute('aria-hidden', 'true');
      trigger.appendChild(arrow);
      var list = document.createElement('div');
      list.id = select.id + '-options';
      list.className = 'apella-sort__options';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', trigger.getAttribute('aria-label'));
      list.hidden = true;
      trigger.setAttribute('aria-controls', list.id);
      var options = Array.from(select.options).filter(function (option) { return !option.disabled && !option.hidden; });
      var active = 0;
      var items = options.map(function (option, index) {
        var item = document.createElement('div');
        item.id = list.id + '-' + index;
        item.className = 'apella-sort__option';
        item.setAttribute('role', 'option');
        item.textContent = option.textContent;
        item.addEventListener('click', function () { choose(index); }, { signal: signal });
        list.appendChild(item);
        return item;
      });
      function sync() {
        var selectedText = select.selectedOptions[0] ? select.selectedOptions[0].textContent.trim() : '';
        var sortLabel = label ? label.textContent.trim().replace(/:\s*$/, '') : 'Sort by';
        caption.textContent = compactSort ? sortLabel : selectedText;
        trigger.setAttribute('aria-label', sortLabel + ': ' + selectedText);
        trigger.title = selectedText;
        items.forEach(function (item, index) { item.setAttribute('aria-selected', String(options[index].value === select.value)); });
      }
      function highlight(index) {
        active = Math.max(0, Math.min(index, items.length - 1));
        items.forEach(function (item, i) { item.classList.toggle('is-active', i === active); });
        if (items[active]) {
          trigger.setAttribute('aria-activedescendant', items[active].id);
          items[active].scrollIntoView({ block: 'nearest' });
        }
      }
      function close() {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.removeAttribute('aria-activedescendant');
      }
      function open() {
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        highlight(options.findIndex(function (option) { return option.value === select.value; }));
      }
      function choose(index) {
        var changed = select.value !== options[index].value;
        select.value = options[index].value;
        sync();
        close();
        trigger.focus({ preventScroll: true });
        if (changed) select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      trigger.addEventListener('click', function () { if (list.hidden) open(); else close(); }, { signal: signal });
      var escaped = false;
      var typed = '';
      var typedAt = 0;
      trigger.addEventListener('keydown', function (event) {
        var key = event.key;
        if (key === 'Escape' && !list.hidden) {
          event.preventDefault();
          event.stopPropagation();
          escaped = true;
          close();
        } else if (key === 'Tab') {
          close();
        } else if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Home' || key === 'End') {
          event.preventDefault();
          if (list.hidden) open();
          else highlight(key === 'Home' ? 0 : key === 'End' ? items.length - 1 : active + (key === 'ArrowDown' ? 1 : -1));
        } else if (key === 'Enter' || key === ' ') {
          event.preventDefault();
          if (list.hidden) open(); else choose(active);
        } else if (key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
          event.preventDefault();
          if (list.hidden) open();
          typed = Date.now() - typedAt > 700 ? key : typed + key;
          typedAt = Date.now();
          var match = options.findIndex(function (option) { return option.textContent.trim().toLowerCase().startsWith(typed.toLowerCase()); });
          if (match >= 0) highlight(match);
        }
      }, { signal: signal });
      trigger.addEventListener('keyup', function (event) {
        if (event.key === 'Escape' && escaped) { event.stopPropagation(); escaped = false; }
      }, { signal: signal });
      list.addEventListener('pointerdown', function (event) { event.preventDefault(); }, { signal: signal });
      this.addEventListener('focusout', function (event) { if (!this.contains(event.relatedTarget)) close(); }, { signal: signal });
      document.addEventListener('click', (event) => { if (!this.contains(event.target)) close(); }, { signal: signal });
      select.addEventListener('change', sync, { signal: signal });
      this.append(trigger, list);
      select.hidden = true;
      this.classList.add('is-enhanced');
      if (label) label.htmlFor = trigger.id;
      sync();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
      this.querySelectorAll('.apella-sort__trigger, .apella-sort__options').forEach(function (element) { element.remove(); });
      var select = this.querySelector('select');
      if (select) select.hidden = false;
      this.classList.remove('is-enhanced');
    }
  }
  if (!customElements.get('apella-sort-select')) customElements.define('apella-sort-select', ApellaSortSelect);

  function bindSortFallback(root) {
    if (root.dataset.apellaSortFallbackBound) return;
    root.dataset.apellaSortFallbackBound = '1';
    root.addEventListener('change', function (event) {
      var select = event.target && event.target.closest ? event.target.closest('select[name="sort_by"]') : null;
      if (!select || !root.contains(select) || !select.value) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = window.ApellaSubcollectionContext
        ? window.ApellaSubcollectionContext.urlForCollectionUpdate(url.toString())
        : url.toString();
    });
  }
  function hydrate(root) {
    updateHeroCount(root);
    initSubcollectionNavigation(root);
    bindDrawer(root);
    syncDrawer(root);
    initInfinite(root);
    initImageReveal(root);
    initImagePreparation(root);
    initCardEntrance(root);
    initCardGalleries(root);
    bindGridRefresh(root);
    bindSortFallback(root);
  }

  function init(scope) {
    var target = scope || document;
    var roots = target.matches && target.matches('[data-apella-plp]') ? [target] : [];
    roots = roots.concat(Array.prototype.slice.call(target.querySelectorAll('[data-apella-plp]')));
    roots.forEach(hydrate);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.matches('[data-apella-plp]') ? [event.target] : Array.prototype.slice.call(event.target.querySelectorAll('[data-apella-plp]'));
    roots.forEach(function (root) {
      if (root.__apellaCardEntrance) root.__apellaCardEntrance.destroy();
      if (root.__apellaImagePreparation) root.__apellaImagePreparation.destroy();
    });
  });
  document.addEventListener('apella:products-loaded', function (event) {
    init((event.detail && event.detail.root) || document);
  });
})();

